var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28493 12.3332H13.2847M1.28516 12.3332H2.40148C2.72759 12.3332 2.89064 12.3332 3.04409 12.2963C3.18013 12.2637 3.31019 12.2098 3.42948 12.1367C3.56403 12.0542 3.67933 11.9389 3.90992 11.7083L12.2848 3.33316C12.8371 2.78087 12.8371 1.88544 12.2848 1.33316C11.7325 0.780874 10.8371 0.780875 10.2849 1.33316L1.90997 9.70832C1.67938 9.93892 1.56408 10.0542 1.48163 10.1888C1.40853 10.3081 1.35466 10.4381 1.322 10.5742C1.28516 10.7276 1.28516 10.8907 1.28516 11.2168V12.3332Z",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit-Icon.d2c3109788c70b69c56f687f4427a8a6.svg";
export { ForwardRef as ReactComponent };